// src/data/projectPreviewData.js

export const projectPreviewData = {
  // ================= SECTIE 1: GRADUATION PROJECTS =================
  "overdetop": {
    h3: "FINAL MASTER PROJECT | 2026",
    h2: "OverDeTop",
    p: "The interactive staircase that turns the pediatric hospital room into a playground",
    img: "/images/Showcase/showcase_overdetop.png"
  },
  "kiko-de-kikker": {
    h3: "PREPARATION FINAL MASTER PROJECT | 2025-2026",
    h2: "Kiko de Kikker",
    p: "Lowering the barrier for early mobilization among hospitalized pediatric patients",
    img: "/images/Showcase/showcase_kiko.png"
  },

  // ================= SECTIE 2: RELEVANT PROJECTS =================
  "physi": {
    h3: "M1.1 DESIGN PROJECT | 2023 - 2024",
    h2: "Physi",
    p: "A playful add-on for data-informed pediatric physiotherapy",
    img: "/images/Showcase/showcase_physi.png"
  },
  "crowdcollab": {
    h3: "DUIET | 2023 - 2024",
    h2: "Crowdcollab",
    p: "Collaborative sense-making for crowd management teams",
    img: "/images/Showcase/showcase_crowdcollab.png"
  },
  "torque": {
    h3: "M1.2 RESEARCH PROJECT | 2024",
    h2: "TORQUE",
    p: "Researching haptic feedback strategies for robotic teleoperation",
    img: "/images/Showcase/showcase_torque.png"
  },
  "microfluidics": {
    h3: "MICROFABRICATION METHODS | 2024",
    h2: "Microfluidic actuator",
    p: "Developing a microfluidic actuator for controlled fluid manipulation",
    img: "/images/Showcase/showcase_microfluidics.png"
  },
  "vitalflow": {
    h3: "DATA-ENABLED DESIGN | 2024",
    h2: "VitalFlow",
    p: "A data-enabled approach for personal informatics systems around breathing monitoring",
    img: "/images/Showcase/showcase_vitalflow.png"
  },
  "bouwplaats": {
    h3: "FINAL BACHELOR PROJECT | 2022",
    h2: "Bouwplaats",
    p: "An interactive XR solution for citizen participation in urban planning",
    img: "/images/Showcase/showcase_bouwplaats.png"
  },

  // ================= SECTIE 3: EXTRACURRICULAR ACTIVITIES =================
  "buto": {
    h3: "HAJRAA OUTDOOR | 2024 - 2025",
    h2: "PR Responsible",
    p: "Organizing Europe’s largest outdoor volleyball tournament and festival.",
    img: "/images/Showcase/showcase_buto.png"
  },
  "tuecontest": {
    h3: "TU/E CONTEST | 2026",
    h2: "Securing two awards",
    p: "A contest for aspiring students to develop their ideas from a business perspective.",
    img: "/images/Showcase/showcase_contest.png"
  },
  "ignite": {
    h3: "TEAM IGNITE | 2024",
    h2: "Technology Designer",
    p: "Designing a large-scale interactive light installation for GLOW Eindhoven.",
    img: "/images/Showcase/showcase_ignite.png"
  }
};